export default __webpack_public_path__ + "static/media/body.7be5c489.png";